/**
 * CUSTOM CHECKBOX, RADIO BUTTONS, SCROLL BAR AND DROP DOWN RELATED FUNCTIONS
 */

/* Custom radio boxes and check boxes */
window.setupLabel = function(currObj) {
    if ($('.wcs-label-check input').length) {
        var $activecheckLabels = $('.wcs-label-check:not(.wcs-inactive)');
        $activecheckLabels.each(function() {
            var $this = $(this);
            $this.parent('.wcs-filter-frame').removeClass('wcs-check');
            $this.removeClass('wcs-c-on').removeClass('wcs-error');
        });
        $activecheckLabels.find('input:checked').each(function() {
            var $this = $(this);
            $this.parents('.wcs-filter-frame').addClass('wcs-check');
            $this.parent('label').addClass('wcs-c-on');
        });
    }
    var $labelRadios = $('.wcs-label-radio');
    if ($labelRadios.find('input').length) {
        $labelRadios.each(function() {
            $(this).removeClass('wcs-r-on');
        });
        $labelRadios.find('input:checked').each(function() {
            $(this).parent('label').addClass('wcs-r-on');
        });
    }
};

window.custom_label = function() {
    $("body").on("click", '.wcs-label-check:not(.wcs-inactive), .wcs-label-radio', function(e) {
        var $this = $(this);
        var inputWrapper = $this.parent();

        //Stops further event propagation and bubbling
        if($this.hasClass("wcs-label-check")) {
            // Fix to stop click event triggering twice
            e.preventDefault();
            var ele = $this.find('input');
            ele.prop('checked', !ele.is(':checked'));
        }
        if ($('.wcs-product-compare').length) {
            addid($this);
        }
        setupLabel($this);

        if(inputWrapper.hasClass("wcs-gw-exapandable-item")){
            enableGiftWrapTextarea(this);
        }

        if ($this.children('input').is('.sameAsDeliveryAddress')) {
            var $billingAddressSection = inputWrapper.find('#billing_address_section');
            if (!($this.find('input').is(':checked'))) {
                $billingAddressSection.removeClass('wcs-hide');
            } else {
                $billingAddressSection.addClass('wcs-hide');
                $('.billing-info-error').hide();
                inputWrapper.find('.exclamatory').remove();
                $billingAddressSection.find('.wcs-error-message').removeClass('wcs-show');
                $billingAddressSection.find('.wcs-row').removeAttr('style').find(".ui-state-error").addClass('ui-state-valid').removeClass("ui-state-error");
                if($this.parents('form').attr('id') !== "user_register_form") {
                    validationSummaryStatus();
                }
            }
            //Publish sameBillingShippingAddress checkbox change event.
            $.publish("BillingAddressUpdated", {
                isSameDeliveryBilling: $(this).find('input').is(':checked')
            });
            //formValidation_onBlur();
            if($('form').attr('id') === 'delivery_information_form'){
                var $agreeConcent = $('#agreeConcent');
                var $nextBlock = $("#next");
                if (!$agreeConcent.is(":checked") && $agreeConcent.length) {
                    $nextBlock.addClass("wcs-btn-disable").attr('disabled', true);
                } else {
                    $nextBlock.removeAttr('disabled').removeClass('wcs-btn-disable');
                }
                var ausurl = $(".wcs-title_logo a").attr('href').indexOf('australia');
                if(ausurl !== -1 && $agreeConcent.parent().hasClass("wcs-c-on")){
                    localStorage.setItem("auscheck", "checked");
                }
            }
        }
        if ($this.children('input').is('.isRfcNeeded')) {
            var $rfc_section = $('#rfc_section');
            $('#WC_PaymentInfoForm_fax1_1').val('')
            $('#rfc_full_name').val('')
            $('[id^="WC_REGIMEN_FISCAL_RFC_"]').val('')
            $('[id^="WC_USO_DE_CFDI_RFC_"]').val('')
            if ($this.find('input').is(':checked')) {
                $rfc_section.removeClass('wcs-hide');
            } else {
                $rfc_section.addClass('wcs-hide');
                $('.billing-info-error').hide();
                inputWrapper.find('.exclamatory').remove();
                var $iw_rfc_section = inputWrapper.find('#rfc_section');
                $iw_rfc_section.find('.wcs-error-message').removeClass('wcs-show');
                $iw_rfc_section.find('.wcs-row').removeAttr('style').find(".ui-state-error").addClass('ui-state-valid').removeClass("ui-state-error");
            }
            //Publish sameBillingShippingAddress checkbox change event.
            $.publish("isRfcNeededUpdated", {
                isRfcNeeded: $(this).find('input').is(':checked')
            });
        }

        var submitBtn;
        var $closestForm = $this.closest("form");
        if ($this.attr("for") === 'agreeConcent_popup') {
            submitBtn = $closestForm.find('#terms_and_conditions_submit');
            var $privacyPolicyAttr = $('#privacyPolicyAttr');
            if ($closestForm.find('#agreeConcent_popup').is(':checked')) {
                submitBtn.removeClass('wcs-btn-disable').attr('disabled', false);
                /**RB-16425, login page privacy policy popup not working on submit***/
                if( $('#pgTemplate').val() === 'DeliveryPage'){
                    $privacyPolicyAttr.val($("#privacyPolicyPref").val());
                }

            } else {
                submitBtn.addClass('wcs-btn-disable').attr('disabled', true);
                $privacyPolicyAttr.val('');
            }
        }
        if ($this.attr("for") === 'agreeConcent' && $("#user_register_form:visible").length) {
            $('#agreeConcent').val("1");
            submitBtn = $closestForm.find('#createAccount');
            if ($this.find(".rb-fieldrow-checkbox__checkmark").length != 0 && $("#pageName").val() != "Login and Register") {
                if ($this.find(".rb-fieldrow-checkbox__checkmark").parent().hasClass("wcs-c-on") && !$("#dateBirth").parent().hasClass("rb-invalidrow"))
                    submitBtn.removeClass('wcs-btn-disable').attr('disabled', false);
                else
                    submitBtn.attr('disabled', true);
            }
            else
                submitBtn.removeClass('wcs-btn-disable').attr('disabled', false);
        }
    });

    $('.wcs-label-check').on('click','a', function() {
        var $labelsCheck = $(this).parents('.wcs-label-check');
        if(!$labelsCheck.hasClass('no-checkbox') && !$(this).closest('.content-fieldset').closest('fieldset').hasClass('privacy-policy-fieldset')){
            $labelsCheck.find('input').prop('checked', false);
            window.open($(this).attr('href'), '_blank');
        }
    });
};

/* Custom Select box */
window.collapse_dropbox = function() {
    var $wcsCustomDropdownSelect = $('.wcs-custom-dropdown-select');
    var currDrpDownObj = $wcsCustomDropdownSelect.siblings('.dropscroller').filter(':not(.wcs-hide)');
    var dropdownRequired = currDrpDownObj.prev('span.wcs-custom-dropdown-select').find('.wcs-dropdown-text').hasClass('wcs-dropdown-validation');
    $('.wcs-dropdown-icon').removeClass('wcs-up');
    $wcsCustomDropdownSelect.removeClass('wcs-dropdown-active');
    $('.dropscroller').addClass('wcs-hide');
    $('.wcs-custom-dropdown-container').removeClass('wcs-border').attr('style', '');
    if (currDrpDownObj && dropdownRequired) {
        show_dropDown_error_message(currDrpDownObj);
    } else {
        hide_dropDown_error_message(currDrpDownObj);
    }
};
window.expand_dropbox = function() {
    $(".wcs-custom-dropdown-select").off("click").on('click', function(e) {
        var $this = $(this);
        var $thisParent = $this.parent();
        var $dropbox = $this.siblings('.dropscroller');
        if ($dropbox.hasClass('wcs-hide')) {
            collapse_dropbox();
            $dropbox.removeClass('wcs-hide');
            $this.find('.wcs-dropdown-icon').addClass('wcs-up');
            $this.addClass('wcs-dropdown-active');
            $thisParent.addClass('wcs-border');
            var droplistHt = $dropbox.find('ul').height();
            if (droplistHt > 160) {
                $dropbox.css({
                    'border-bottom': '1px solid #333',
                    'height': '160px'
                }).find('ul').css('border-bottom', 'none');
            } else {
                $dropbox.height(droplistHt + 12 + 'px');
            }
            dropscrollerFn();
            var borderColor = '#333';
            if ($thisParent.hasClass('wcs-size')) {
                borderColor = '#d6d6d6';
            }
            $this.next('div.dropscroller').find('ul.wcs-custom-dropdown').css('border-color', borderColor);
            $this.parent('div.wcs-custom-dropdown-container').css('border-color', borderColor);
            e.stopPropagation();
        } else {
            collapse_dropbox();
            $thisParent.removeClass('wcs-border');
        }
    });
};

/* keyboard navigation for dropdowns */
var li_count = 0;
var li_position = 0;
window.key_nav_dropdown = function() {
    var $wcsDropdownText = $('.wcs-dropdown-text');
    $wcsDropdownText.focus(function() {
        var $this = $(this);
        var d_selected_text = $this.val();
        $this.parents('.wcs-custom-dropdown-container').find('li').each(function() {
            var $that = $(this);
            if ($that.text() === d_selected_text) {
                li_position = $that.index() + 1;
            }
        });
        li_count = li_position;
    });
    $wcsDropdownText.keydown(function(e) {
        var $this = $(this);
        var $dropdownContainer = $this.parents('.wcs-custom-dropdown-container');
        var $dropdownItems = $dropdownContainer.find('li');
        var $dropScrollerInput = $dropdownContainer.find('.dropscroller input');
        var li_length = $dropdownItems.length;
        var li_value,data_Option;
        if (e.which === 40) {
            if (li_length > li_count) {
                li_value = $dropdownItems.eq(li_count).text();
                data_Option = $dropdownItems.eq(li_count).attr('data-optionvalue');

                li_count += 1;
                $this.val(li_value);
                if (data_Option) {
                    $dropScrollerInput.val(data_Option);
                } else {
                    $dropScrollerInput.val(li_value);
                }
                $this.removeClass('wcs-dropdown-validation').parents('.wcs-custom-dropdown-container').removeClass('ui-state-error');
            }
        } else if (e.which === 38) {
            if (li_count > 1) {
                li_count -= 1;
                li_value = $dropdownItems.eq(li_count - 1).text();
                data_Option = $dropdownItems.eq(li_count - 1).attr('data-optionvalue');
                $this.val(li_value);
                if (data_Option) {
                    $dropScrollerInput.val(data_Option);
                } else {
                    $dropScrollerInput.val(li_value);
                }
            }
        } else if (e.which === 9) {
            if ($this.hasClass('wcs-dropdown-validation')) {
                show_dropDown_error_message($this);
            } else {
                hide_dropDown_error_message($this);
            }
            collapse_dropbox();
        } else {
            return false;
        }
    });
};

window.select_dropbox_value = function() {
    $('.wcs-custom-dropdown li').off('click').on('click', function() {

        var remove_err = function(that) {
            $(that).parents('.wcs-custom-dropdown-container').find('.wcs-dropdown-text')
                .parents('.wcs-row').attr('style', '').find('.wcs-error-message').removeClass('wcs-show');
        };

        var $this = $(this);
        var text = $this.html();
        if ($this.children('.wcs-selectedSizeText').length) {
            text = $this.find('.wcs-selectedSizeText').html();
        }
        var dataOption = $this.attr('data-optionvalue');
        var $dropscroller = $this.parents('.dropscroller');
        var linked = $dropscroller.data('linked');

        if (linked) {
            var linked_val = $('#' + linked).val();
            if (linked_val !== '') {
                remove_err(this);
            }
        } else {
            remove_err(this);
        }

        $dropscroller.addClass('wcs-hide').parent().find('.wcs-dropdown-icon').removeClass('wcs-up');
        $this.parents('.wcs-custom-dropdown').removeClass('wcs-dropdown-active');

        var $dropdownContainer = $this.parents('.wcs-custom-dropdown-container');
        var $dropdownText = $dropdownContainer.find('.wcs-dropdown-text');

        $dropdownText
            .removeClass('wcs-dropdown-validation').val(text)
            .parents('.wcs-custom-dropdown-container').removeClass('ui-state-error');

        if (dataOption) {
            $dropdownContainer.find('.dropscroller input').val(dataOption);
            $dropdownText.val(text);
        } else {
            $dropdownContainer.find('input').val(text);
            if ($("#wcs-myDetails").val() === "My Details") {
                var $wcsDayLoad = $("#wcs-day-load");
                var $wcsDayLoadParentParent = $wcsDayLoad.parent().parent();

                var getDay = $wcsDayLoad.text();
                var getMonth = $("#wcs-month-load").text();
                var getYear = $("#wcs-year-load").text();
                /* Condition to change date according to month selection */
                var $myOrderDayList = $('ul[data-attr="wcs-myOrder-day"]');
                var $myOrderDayListItems = $myOrderDayList.find('li');
                if (getMonth === "2") {
                    if (getDay === "30" || getDay === "31" || getDay === "29") {
                        $wcsDayLoadParentParent.addClass("ui-state-error");
                    }
                    $myOrderDayList.find('li:gt(-4)').addClass('wcs-hide');
                } else if (getMonth === "4" || getMonth === "6" || getMonth === "9" || getMonth === "11") {
                    if (getDay === "31") {
                        $wcsDayLoadParentParent.addClass("ui-state-error");
                    }
                    $myOrderDayList.find('li:gt(-2)').addClass('wcs-hide');
                } else {
                    $myOrderDayListItems.removeClass('wcs-hide');
                }
                /* Condition to find leap year */
                if (((getYear % 4 === 0) && (getYear % 100 !== 0)) || (getYear % 400 === 0)) {
                    /* Function to check the month inside leap year and change the date */
                    if (getMonth == "2") {
                        $myOrderDayListItems.removeClass('wcs-hide');
                        $myOrderDayList.find('li:gt(-3)').addClass('wcs-hide');
                    } else {
                        $myOrderDayListItems.removeClass('wcs-hide');
                    }
                }
            }
        }

        if ($this.parents('div.wcs-credit-card').index() !== -1) {
            var card_info_area = $('.wcs-icon.wcs-card-verification-icon');
            var v = $('.wcs-credit-card').find('input').val();
            var $amexInfo = card_info_area.find('.amex-info');
            var $notAmexInfo = card_info_area.find('.not-amex-info');
            if (v === 'AMEX') {
                card_info_area.addClass('wcs-card-verification-dark-icon');
                $amexInfo.removeClass('wcs-hide');
                $notAmexInfo.addClass('wcs-hide');
            } else {
                card_info_area.removeClass('wcs-card-verification-dark-icon');
                $amexInfo.addClass('wcs-hide');
                $notAmexInfo.removeClass('wcs-hide');
            }
        }

        $this.parent('ul').next().trigger('blur');
        if ($('#pdpType').val() === 'giftCard') {
            var id = $this.attr("id");
            var params = {};
            params.giftCardId = id;
            params.storeId = $('#storeId').val();
            params.catalogId = $('#catalogId').val();
            params.langId = $('#langId').val();
            params.GiftCardType = $('#GiftCardType').val();

            $.ajax({
                type: "GET",
                url: "GiftCardAddToBagView",
                data: params,
                dataType: 'html',
                cache: false,
                async: false,
                success: function(response) {
                    var addItemHtml = $(response).find('#addProdItem'),
                        favHtml = $(response).find('div.wcs-right').parent()[1].innerHTML;
                    $('.wcs-qty-container>div.wcs-right').html(addItemHtml);
                    $('.wcs-fav-container').html(favHtml);
                }
            });
        }

        if ($this.attr('qtyval') === 'wcs-pdp') {
            $this.parents('.wcs-qty-container').find('form #quantity').val($this.attr("qty-sku"));
        }

        var targetSKU ;
        if ($this.attr('idval') === 'wcs-pdp') {
            var jsonval = $('#wcs-PDP-json1').html();
            var data = $.parseJSON(jsonval);

            targetSKU = $this.attr('data-sku');
            pdpDataChange(targetSKU);
            pdpJSON2(data[targetSKU].catentryId, targetSKU);
            if ($('#wcs-pageName').val() === 'productDisplayPage') {
                var productDisplayPageNewDesign = $('#productDisplayPageNewDesign').val();
                if (productDisplayPageNewDesign == 'true') {
                    PDPCrossSell(sku);
                }
            }
        }
        /* for size drop down --wcs-quickview*/
        if ($this.attr('idval') === 'wcs-quickview') {
            targetSKU = $this.attr('data-sku');
            var changeSize = 'FALSE';
            change_product_properties(targetSKU, changeSize);
        }
        if ($this.parents().is('.wcs-dob-validate')) {
            var day = $('#wrapper4val').val();
            var month = $('#wrapper5val').val();
            var year = $('#wrapper6val').val();

            //Validating user's age, should be greater than 18 years old
            if (day !== "" || month !== "" || year !== "") {
                var dobYearValidation = $("#wcs-dob_validation").val();
                var ageValidationError = $("#wcs-dob_error_msg").val();
                var inputMonth = month - 1; //Month Range 0-11
                var today = new Date();
                var currYear = today.getFullYear();
                var currMonth = today.getMonth();
                var currDay = today.getDate();
                var diffYear = currYear - year;
                var diffMonth = currMonth - inputMonth;
                var diffDay = currDay - day;
                $("#wcs-dob-subscribe-error").removeClass("wcs-show").hide();
                var $wcsDobError = $("#wcs-dob-error");
                var $wcsDobValidate = $this.parents('.wcs-dob-validate');
                var $customDropdownContainer = $wcsDobValidate.find('.wcs-custom-dropdown-container');
                var $wcsSave = $('#wcs-save');
                if (diffYear > dobYearValidation || (diffYear == dobYearValidation && diffMonth === 0 && diffDay > 0) || (diffYear == dobYearValidation && diffMonth >= 1)) {
                    $wcsDobError.removeClass("wcs-show").hide();
                    $wcsDobValidate.css('color', '#333333')
                    $customDropdownContainer.removeClass('wcs-red-border');
                    $wcsSave.removeClass('wcs-btn-disable');
                } else {
                    $wcsDobError.addClass("wcs-show").show();
                    $wcsDobValidate.css('color', '#EC1E24')
                    $customDropdownContainer.addClass('wcs-red-border');
                    $wcsSave.addClass('wcs-btn-disable');
                }
            }
        }
    });
};

/* Custom Dropdown Scroller */
var myDropScroll = [];
window.dropscrollerFn = function() {
    if (myDropScroll.length > 0) {
        for (var i = 0; i < myDropScroll.length; i++) {
            myDropScroll[i].destroy();
        }
    }
    $('.dropscroller').each(function() {
        id = $(this).attr('id');
        var dropht = $(this).height();
        if (dropht > 159) {
            myDropScroll.push(new iScroll(this, {
                hScrollbar: false,
                draggableScrollbars: true
            }));
        }
    });
};

/* Disable windows scroll when custom scroll is enabled */
window.custom_scrollable_hover = function() {
    var $document = $(document);

    $('.dropscroller, .scrollable, .wcs-shopping-scroller,.wcs-content-support').hover(function() {
        $document.bind('mousewheel DOMMouseScroll', function(e) {
            scrollerHandler();
        });
    }, function() {
        $document.unbind('mousewheel DOMMouseScroll');
    });
    /* Disable windows scroll when custom scroll is enabled */
    window.dropscroller_hover_fn = function() {
        $('.dropscroller, .scrollable,.dropdown-list').unbind('mouseenter mouseleave').hover(function() {
            $document.bind('mousewheel DOMMouseScroll', function(e) {
                scrollerHandler();
            });
        }, function() {
            $document.unbind('mousewheel DOMMouseScroll');
        });
    };
    dropscroller_hover_fn();

    function scrollerHandler() {
        var $html = $('html');
        var $wcsDepositContainer = $('.wcs-deposit-container');

        if (!$html.hasClass('ie8')) {
            stopWheel(e);
        } else {
            if (!$wcsDepositContainer.is(':visible')) {
                $wcsDepositContainer.slideDown('slow');
            }
        }
    }

    function stopWheel(e) {
        if (!e) { /* IE7, IE8, Chrome, Safari */
            e = window.event;
        }
        if (e.preventDefault) { /* Chrome, Safari, Firefox */
            e.preventDefault();
        }
        e.returnValue = false; /* IE7, IE8 */
    }
    $('.wcs-right-panel .wcs-empty-text').hover(function() {
        $document.unbind('mousewheel DOMMouseScroll');
    });
};

/* ------------------------------------------------------------------------------------
		CUSTOM CHECKBOX, RADIO BUTTONS, SCROLL BAR AND DROP DOWN RELATED FUNCTIONS ENDS
		-------------------------------------------------------------------------------------*/
